import instance from "../apis/axiosConfig";


export const loginauth = async (data) => {
  return instance.post("auth/login", data);
};
